import { useState } from "react";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import PageHero from "../components/site/PageHero";
import { Field, FileField, SuccessPanel, useEnquiryForm, inputCls } from "../components/forms/fields";
import { FadeUp } from "../components/site/Reveal";

const INITIAL = {
    organisation: "",
    country: "",
    contactPerson: "",
    position: "",
    website: "",
    email: "",
    partnershipType: "",
    marketsCovered: "",
    proposalSummary: "",
    preferredContactMethod: "",
};

export default function PartnershipEnquiry() {
    const [form, setForm] = useState(INITIAL);
    const [file, setFile] = useState(null);
    const { submitting, reference, submit } = useEnquiryForm("partnership");
    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const onSubmit = (e) => {
        e.preventDefault();
        submit(form, file, true);
    };

    return (
        <div className="grain bg-navy-deep" data-testid="partnership-enquiry-page">
            <Header />
            <main>
                <PageHero
                    seo={{
                        title: "Partnership Enquiry | Work with Viet Medica Ltd",
                        description:
                            "Propose a partnership with Viet Medica Ltd — healthcare providers, suppliers, distributors and business partners across international markets.",
                        path: "/partnership-enquiry",
                    }}
                    crumbs={[{ label: "Contact", href: "/contact" }, { label: "Partnership Enquiry" }]}
                    eyebrow="Business Partnerships"
                    title="Partnership"
                    titleEm="Enquiry."
                    copy="Tell us about your organisation and the partnership you have in mind. Your proposal is reviewed by the relevant division — healthcare, trading or sourcing."
                />

                <section className="bg-navy-deep py-16 lg:py-24">
                    <div className="mx-auto max-w-3xl px-5 lg:px-10">
                        {reference ? (
                            <SuccessPanel reference={reference} categoryLabel="partnership" />
                        ) : (
                            <FadeUp>
                                <form onSubmit={onSubmit} className="space-y-6 border border-white/10 bg-navy-surface p-7 lg:p-10" data-testid="partnership-enquiry-form">
                                    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                                        <Field label="Organisation" htmlFor="pt-org" required>
                                            <input id="pt-org" data-testid="pt-org" required className={inputCls} value={form.organisation} onChange={set("organisation")} />
                                        </Field>
                                        <Field label="Country" htmlFor="pt-country" required>
                                            <input id="pt-country" data-testid="pt-country" required className={inputCls} value={form.country} onChange={set("country")} />
                                        </Field>
                                        <Field label="Contact Person" htmlFor="pt-person" required>
                                            <input id="pt-person" data-testid="pt-person" required className={inputCls} value={form.contactPerson} onChange={set("contactPerson")} />
                                        </Field>
                                        <Field label="Position" htmlFor="pt-position">
                                            <input id="pt-position" data-testid="pt-position" className={inputCls} value={form.position} onChange={set("position")} />
                                        </Field>
                                        <Field label="Website" htmlFor="pt-website">
                                            <input id="pt-website" data-testid="pt-website" type="url" className={inputCls} value={form.website} onChange={set("website")} placeholder="https://" />
                                        </Field>
                                        <Field label="Email" htmlFor="pt-email" required>
                                            <input id="pt-email" data-testid="pt-email" required type="email" className={inputCls} value={form.email} onChange={set("email")} />
                                        </Field>
                                        <Field label="Partnership Type" htmlFor="pt-type" required>
                                            <select id="pt-type" data-testid="pt-type" required className={inputCls} value={form.partnershipType} onChange={set("partnershipType")}>
                                                <option value="">Select…</option>
                                                <option>Healthcare Provider or Hospital</option>
                                                <option>Clinic or Specialist Practice</option>
                                                <option>Supplier or Exporter</option>
                                                <option>Distribution or Agency</option>
                                                <option>Travel or Visa Services</option>
                                                <option>Other</option>
                                            </select>
                                        </Field>
                                        <Field label="Markets Covered" htmlFor="pt-markets">
                                            <input id="pt-markets" data-testid="pt-markets" className={inputCls} value={form.marketsCovered} onChange={set("marketsCovered")} placeholder="e.g. UAE, East Africa" />
                                        </Field>
                                        <Field label="Preferred Contact Method" htmlFor="pt-contact">
                                            <select id="pt-contact" data-testid="pt-contact" className={inputCls} value={form.preferredContactMethod} onChange={set("preferredContactMethod")}>
                                                <option value="">Select…</option>
                                                <option>Email</option>
                                                <option>WhatsApp</option>
                                                <option>Telephone</option>
                                            </select>
                                        </Field>
                                    </div>
                                    <Field label="Proposal Summary" htmlFor="pt-proposal" required>
                                        <textarea id="pt-proposal" data-testid="pt-proposal" required rows={4} className={inputCls} value={form.proposalSummary} onChange={set("proposalSummary")} />
                                    </Field>
                                    <Field label="Supporting Documents" htmlFor="pt-file" hint="Optional. PDF, PNG or JPG, max 3 MB.">
                                        <FileField id="pt-file" file={file} onChange={setFile} />
                                    </Field>
                                    <button
                                        type="submit"
                                        disabled={submitting}
                                        data-testid="pt-submit"
                                        className="w-full bg-gold px-6 py-4 text-xs font-bold uppercase tracking-[0.2em] text-navy-deep transition-colors hover:bg-gold-bright disabled:opacity-50"
                                    >
                                        {submitting ? "Sending…" : "Send Partnership Enquiry"}
                                    </button>
                                </form>
                            </FadeUp>
                        )}
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
